import { Typography } from "@mui/material";

import MetaDetails from "./components/MetaDetails";

const ChangeRequestOverview = ({ data ,projectDetails}) => {
  const images = data?.requestImages ? JSON.parse(data.requestImages) : [];
  return (
    <div
      style={{
        marginTop: "10px",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <MetaDetails data={data} projectDetails={projectDetails}/>
      <Typography fontSize={14} fontWeight={500} color="text.secondary">
        Change Request Details:
      </Typography>
      <Typography fontSize={14} fontWeight={500}>
        {data?.requestDescription || "-"}
      </Typography>
      <div style={{ display: "flex", flexWrap: "no-wrap", gap: "10px", overflowX: "auto" }}>
        {images.map((image) => (
          <img
            key={image.blobFileId}
            src={image.url}
            style={{ height: "200px", width: "200px", marginRight: "10px", borderRadius: "10px" }}
          />
        ))}
      </div>
    </div>
  );
};

export default ChangeRequestOverview;
